import { DATA_UNIT } from './models/media';
export var RECENTS_COLLECTION = 'recents';
export var FILE_CACHE_MAX_AGE = 60 * 60 * 24 * 30; // Retain for 30 days
export var MAX_RESOLUTION = 4096;
export var CHUNK_SIZE = 5 * DATA_UNIT.MB;
export var PROCESSING_BATCH_SIZE = 1000;
export var MAX_UPLOAD_FILE_SIZE = 2 * DATA_UNIT.TB;